import type { CustomerData } from "../../services/api";
import type { MenuItem } from "../../interfaces";

export interface SendPushData {
  programId: string;
  email: string;
  customer: CustomerData;
  /** The link variables of the program, which the page knows. */
  linkVariables: MenuItem[];
}

/** True once the push is sent. */
export type SendPushResult = boolean;

/** Pushes reach customers who accept marketing notifications and have the wallet pass installed. */
export const canReceivePush = ({ customer, passes }: CustomerData): boolean =>
  !!customer.marketingNotifications && (passes?.apple ?? 0) + (passes?.google ?? 0) > 0;
